import { useEffect } from "react";
import { Publications } from "@/components/site/Publications";
import { scrollToTop } from "@/lib/scroll";
export default function PublicationIndex(){useEffect(()=>scrollToTop(),[]);return <Publications/>;}
